import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../../../react-core/Flux/BaseStore";
import { ProductType } from "../../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";
import { DrawdownCalculationStoreDispatcher } from "./Variable";

export interface DrawdownCalculationStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export interface ChooseAssetsToSellAssets {
    Assets: string;
    MarketValue: Money;
    Id: number;
    ProductType: ProductType;
    DisinvestAll: boolean;
    FactsheetUrl: string;
    IsDeferred?: boolean;
    HasOpenValueSellOrder?: boolean
}

export interface ChooseAssetsToSwitchAssets {
    ProductId: number;
    Assets: string;
    ProductType: ProductType;
    MarketValue?: Money;
    SwitchAll?: boolean;
    FactsheetUrl?: string;
    ProductCode?: string;
    IsDeferred?: boolean;
    HasOpenValueSellOrder?: boolean
}

export class DrawdownCalculationStoreStatic extends BaseStore<DrawdownCalculationStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(DrawdownCalculationStoreDispatcher, (actionData) =>
            this.onDrawdownCalculationStoreStoreResponse(actionData)
        );
    }

    public getLastResult(): DrawdownCalculationStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): DrawdownCalculationStoreStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onDrawdownCalculationStoreStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType, isLoading: actionData.payload });
                break;
        }
    }
}
